import { SVGProps, Ref, forwardRef } from 'react';

export const LinkOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M11.554 2.005c-.848.242-1.816.896-2.734 1.814-.29.29-.555.586-.787.881l-.996-.996c.246-.302.513-.595.793-.875C9.833.826 12.505-.51 14.509 1.495c2.004 2.003.668 4.675-1.336 6.679s-4.675 3.34-6.68 1.336a3.6 3.6 0 0 1-.585-.754l1.06-1.06c.083.287.25.559.516.824.59.59 1.21.694 1.965.479.847-.243 1.816-.897 2.734-1.815.918-.919 1.572-1.887 1.815-2.734.215-.755.111-1.375-.48-1.965-.59-.59-1.21-.695-1.964-.48"
                    fill="currentColor"
                />
                <path
                    d="M4.446 13.995c.848-.242 1.816-.896 2.734-1.814q.437-.437.787-.881l.996.996c-.246.302-.513.595-.793.874-2.003 2.004-4.675 3.34-6.679 1.336S.823 9.831 2.827 7.827s4.676-3.34 6.68-1.336q.36.362.582.75L9.03 8.297c-.085-.284-.251-.553-.515-.817-.59-.59-1.21-.694-1.965-.479-.847.243-1.816.897-2.734 1.815s-1.572 1.887-1.815 2.734c-.215.755-.111 1.375.48 1.965.59.59 1.21.695 1.964.48"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LinkOutlinedSize16Glyph.displayName = 'LinkOutlinedSize16Glyph';
